module.exports = __webpack_public_path__ + "static/media/komsek.4fc2b933.png";